module.exports = __webpack_public_path__ + "img/search.9fc2f97f.svg";